// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","rotation":"Loader_rotation__zW3DX","fullsize":"Loader_fullsize__9DQ0V"};